var exports = {
  "D": "Box_0__W55SAU",
  "J": "Octicon_0__bMlnt4",
};

module.exports = exports;
